export default __webpack_public_path__ + "static/media/avatar.6f3d1057.png";